import { Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import { RequestsService } from '../../services/requests.service';
import { ToastService } from '../../services/toast.service';
import { AddProjetoComponent } from '../../components/add-projeto/add-projeto.component';
import { AddTenantComponent } from '../../components/add-tenant/add-tenant.component';
import { AddDatasetComponent } from '../../components/add-dataset/add-dataset.component';
import { AddCabecalhoComponent } from '../../components/add-cabecalho/add-cabecalho.component';
import { AddTemplateComponent } from '../../components/add-template/add-template.component';
import { Projeto } from '../../models/projeto.model';
import { Tenant } from '../../models/tenant.model';
import { Dataset } from '../../models/dataset.model';
import { Cabecalho } from '../../models/cabecalho.model';
import { Template } from '../../models/template.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';


@Component({
  selector: 'app-counter-component',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
})
export class CounterComponent implements OnInit, AfterViewInit {
  public projetos: Projeto[];
  public tenants: Tenant[];
  public templates: Template[];
  public cabecalhos: Cabecalho[];
  public datasets: Dataset[];
  public disableDelete: boolean;

  selection = new SelectionModel<Projeto>(false, []);

  displayedColumnsProjeto: string[] = ['select', 'editar', 'excluir', 'id', 'nome'];
  dataSourceProjeto: MatTableDataSource<Projeto>;

  displayedColumnsTenant: string[] = ['editar','excluir', 'id', 'nome', 'multiTenant', 'distinctor'];
  dataSourceTenant: MatTableDataSource<Tenant>;

  displayedColumnsDataset: string[] = ['editar', 'excluir', 'id', 'nome'];
  dataSourceDataset: MatTableDataSource<Dataset>;

  displayedColumnsCabecalho: string[] = ['editar', 'live-view', 'clone','excluir', 'id', 'nome', 'nomeDataset'];
  dataSourceCabecalho: MatTableDataSource<Cabecalho>;

  displayedColumnsTemplate: string[] = ['editar', 'live-view', 'excluir', 'id', 'nome', 'cabecalho', 'dataset'];
  dataSourceTemplate: MatTableDataSource<Template>;



  @ViewChild('paginatorProjeto') paginator: MatPaginator;
  @ViewChild('paginatorTenant') paginatorTenant: MatPaginator;
  @ViewChild('paginatorCabecalho') paginatorCabecalho: MatPaginator;
  @ViewChild('paginatorTemplate') paginatorTemplate: MatPaginator;
  @ViewChild('paginatorDataset') paginatorDataset: MatPaginator;

  @ViewChild('modalProjeto', { static: true }) private modalProjeto: AddProjetoComponent
  @ViewChild('modalTenant', { static: true }) private modalTenant: AddTenantComponent
  @ViewChild('modalDataset', { static: true }) private modalDataset: AddDatasetComponent
  @ViewChild('modalCabecalho', { static: true }) private modalCabecalho: AddCabecalhoComponent
  @ViewChild('modalTemplate', { static: true }) private modalTemplate: AddTemplateComponent

  constructor(private requestService: RequestsService,
    private toastService: ToastService) {

  }

  addProjeto(registro) {
    this.modalProjeto.abrir(registro).then(x => {
      this.carregarProjetos();
    });
  }

  addTenant(registro) {      
    this.modalTenant.abrir(registro, this.selection.selected[0].idProjeto).then(x => {
      this.carregarTenants(this.selection.selected[0].idProjeto);
    });
  }

  addDataset(registro) {
    this.modalDataset.abrir(registro, this.selection.selected[0].idProjeto).then(x => {
      this.carregarDatasets(this.selection.selected[0].idProjeto);
    });
  }

  addCabecalho(registro) {
     this.modalCabecalho.abrir(registro, this.selection.selected[0].idProjeto).then(x => {
       this.carregarCabecalhos(this.selection.selected[0].idProjeto);
    });
  }

  addTemplate(registro) {
    this.modalTemplate.abrir(registro, this.selection.selected[0].idProjeto).then(x => {
      this.carregarTemplates(this.selection.selected[0].idProjeto);
    });
  }

  excluirProjeto(id,i) {
    this.modalProjeto.delete(id).then(x => {
      if (x) {
        this.requestService.deleteProjeto(id).subscribe(rst => {
          this.carregarProjetos();
          this.toastService.showSuccess("Projeto excluído com sucesso.");
          this.disableDelete = false;
        }, error => {
          this.disableDelete = false;
        });
      }
      else {
        this.disableDelete = false;
      }
 
    });
  }

  excluirTenant(id) {
    this.modalTenant.delete(id).then(x => {
      if (x) {
        this.requestService.deleteTenant(id).subscribe(rst => {
          this.carregarTenants(this.selection.selected[0].idProjeto);
          this.toastService.showSuccess("Tenant excluído com sucesso.");
          this.disableDelete = false;
        }, error => {
          this.disableDelete = false;
        });
      }
      else {
        this.disableDelete = false;
      }
    });
  }

  excluirDataset(id) {
    this.modalDataset.delete(id).then(x => {
      if (x) {
        this.requestService.deleteDataset(id).subscribe(rst => {
          this.carregarDatasets(this.selection.selected[0].idProjeto);
          this.toastService.showSuccess("Dataset excluído com sucesso.");
          this.disableDelete = false;
        }, error => {
          this.disableDelete = false;
        });
      }
      else {
        this.disableDelete = false;
      }
    });
  }

  excluirCabecalho(id) {
    this.modalCabecalho.delete(id).then(x => {
      if (x) {
        this.requestService.deleteCabecalho(id).subscribe(rst => {
          this.carregarCabecalhos(this.selection.selected[0].idProjeto);
          this.toastService.showSuccess("Cabeçalho excluído com sucesso.");
          this.disableDelete = false;
        }, error => {
          this.disableDelete = false;
        });
      }
      else {
        this.disableDelete = false;
      }
    });
  }

  excluirTemplate(id) {
    this.modalTemplate.delete(id).then(x => {
      if (x) {
        this.requestService.deleteTemplate(id).subscribe(rst => {
          this.carregarTemplates(this.selection.selected[0].idProjeto);
          this.toastService.showSuccess("Template excluído com sucesso.");
          this.disableDelete = false;
        }, error => {
          this.disableDelete = false;
        });
      }
      else {
        this.disableDelete = false;
      }
    });
  }

  cloneCabecalho(registro) {
    this.modalCabecalho.clone(registro).then(x => {
    });
  }

  carregarProjetos() {
    this.requestService.listProjetos().subscribe(rst => {
      this.projetos = rst;
      this.dataSourceProjeto = new MatTableDataSource<Projeto>(this.projetos);
      this.dataSourceProjeto.paginator = this.paginator;
    });
  }

  carregarTenants(idProjeto) {
      this.requestService.listTenantsByProjeto(idProjeto).subscribe(rst => {
        this.tenants = rst;
        this.dataSourceTenant = new MatTableDataSource<Tenant>(this.tenants);
        this.dataSourceTenant.paginator = this.paginatorTenant;
      });
  }

  carregarDatasets(idProjeto) {
      this.requestService.listDatasetsByProjeto(idProjeto).subscribe(rst => {
        this.datasets = rst;
        this.dataSourceDataset = new MatTableDataSource<Dataset>(this.datasets);
        this.dataSourceDataset.paginator = this.paginatorDataset;
      });
  }

  carregarTemplates(idProjeto) {
      this.requestService.listTemplatesByProjeto(idProjeto).subscribe(rst => {
        this.templates = rst;
        this.dataSourceTemplate = new MatTableDataSource<Template>(this.templates);
        this.dataSourceTemplate.paginator = this.paginatorTemplate;
      });
  }

  carregarCabecalhos(idProjeto) {
     this.requestService.listCabecalhosByProjeto(idProjeto).subscribe(rst => {
        this.cabecalhos = rst;
        this.dataSourceCabecalho = new MatTableDataSource<Cabecalho>(this.cabecalhos);
        this.dataSourceCabecalho.paginator = this.paginatorCabecalho;
      });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceProjeto.data.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSourceProjeto.data.forEach(row => this.selection.select(row));
  }

  ngOnInit() {
    this.disableDelete = false;
  }

  ngAfterViewInit() {
    this.carregarProjetos();
    this.selection.changed.subscribe(x => {
      if (this.selection.hasValue()) {
        this.carregarTenants(x.source.selected[0].idProjeto);
        this.carregarCabecalhos(x.source.selected[0].idProjeto);
        this.carregarDatasets(x.source.selected[0].idProjeto);
        this.carregarTemplates(x.source.selected[0].idProjeto);
      }
      else {
        this.dataSourceTenant = new MatTableDataSource<Tenant>();
        this.dataSourceDataset = new MatTableDataSource<Dataset>();
        this.dataSourceCabecalho = new MatTableDataSource<Cabecalho>();
        this.dataSourceTemplate = new MatTableDataSource<Template>();
      }
    })

  }
}
